import ProfileIcon from "@enerex/unified-ui-react/icons/ProfileIcon";

const profileMenus = [
    {
        label: 'My Profile',
        icon: <ProfileIcon />,
        redirectTo: '/Profile',
    },
    // {
    //     label: 'Accounts',
    //     icon: 'uil-user',
    //     redirectTo: '/settings/users',
    //     requireAdminAccess: true
    // }
    //{
    //    label: 'Settings',
    //    icon: 'mdi mdi-account-edit',
    //    redirectTo: '/',
    //},
    //{
    //    label: 'Support',
    //    icon: 'mdi mdi-lifebuoy',
    //    redirectTo: '/',
    //},
    //{
    //    label: 'Lock Screen',
    //    icon: 'mdi mdi-lock-outline',
    //    redirectTo: '/account/lock-screen',
    //}
    // {
    //     label: 'Logout',
    //     icon: 'mdi mdi-logout',
    //     redirectTo: '/account/logout',
    // },
];

export default profileMenus;

